module.exports = __webpack_public_path__ + "img/office.7508d629.png";